<template>
  <div class="modal fade modal-load-request" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          Request Details
        </div>
        <div class="modal-body">

          <h3 class="m-b-lg">{{ load.commodity_and_location }}</h3>

          <div class="row row-clear-sm-6">
            <div class="col-sm-6">
              <p class="material-details">
                <strong>Loading Date</strong><br />
                {{ load.loading_date }}
              </p>
            </div>
            <div class="col-sm-6">
              <p class="material-details">
                <strong>Loading Time</strong><br />
                {{ load.loading_time }}
              </p>
            </div>
            <div class="col-sm-6">
              <p class="material-details">
                <strong>Delivery Date</strong><br />
                {{ load.delivery_date }}
              </p>
            </div>
            <div class="col-sm-6">
              <p class="material-details">
                <strong>Delivery Time</strong><br />
                {{ load.delivery_time }}
              </p>
            </div>
            <div class="col-sm-6">
              <p class="material-details lead">
                <strong>Rate</strong><br />
                {{ load.rate }}
              </p>
            </div>
          </div>

          <div class="map-container">
            <distance-map ref="map" :location-from="load.location_from" :location-to="load.location_to"></distance-map>
          </div>

        </div>
        <div class="modal-footer">
          <div class="row">
            <div class="col-sm-6 footer-left">
              <button type="button" class="btn btn-sm btn-default" data-dismiss="modal">Close</button>
            </div>
            <div class="col-sm-6 footer-right">
              <ladda-button type="danger" :disabled="!canEditLoadRequests" size="small" ref="decline" :on-click="handleDeclineRequest">Decline</ladda-button>
              <ladda-button type="success" :disabled="!canEditLoadRequests" size="small" ref="accept" :on-click="handleAcceptRequest">Accept</ladda-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex'
  import { RESET_LOAD } from 'vx/mutations'
  import { LaddaButton } from 'components/forms'
  import { loadRequestActionsHelpers } from 'mixins/loads'
  import DistanceMap from 'components/jobs/DistanceMap'
  import $ from 'jquery'

  export default {
    components: {
      DistanceMap,
      LaddaButton
    },

    mixins: [loadRequestActionsHelpers],

    computed: {
      ...mapGetters('load', { load: 'loadDecorated' }),

      canEditLoadRequests () {
        return this.$user.isEnabled
      }
    },

    mounted () {
      $(this.$el).on('shown.bs.modal', this.distanceMapReady)
      $(this.$el).on('hidden.bs.modal', this[RESET_LOAD])
    },

    beforeDestroy () {
      $(this.$el).off('shown.bs.modal', this.distanceMapReady)
      $(this.$el).off('hidden.bs.modal', this[RESET_LOAD])
    },

    methods: {
      ...mapMutations('load', [RESET_LOAD]),
      ...mapActions('load', ['acceptLoad', 'declineLoad']),

      /**
       * Emit the ready event on the distance map component.
       *
       * @return void
       */
      distanceMapReady () {
        this.$refs.map.$emit('ready')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LoadRequestModal.vue?47f6d077